export type KundaliLang = "en" | "hi";

export interface KundaliTranslations {
  name: string;
  birthDate: string;
  birthTime: string;
  birthPlace: string;
  optional: string;
  timeUnknownToggle: string;
  timeUnknownExplainer: string;
  submit: string;
  namePlaceholder: string;
  placePlaceholder: string;
  savedNote: string;
  loading: string;
  phone: string;
  phonePlaceholder: string;
  phoneReason: string;
  email: string;
  emailPlaceholder: string;
  placeChange: string;
  placeDidYouMean: string;
  retryTitle: string;
  retryBody: string;
  retryAction: string;
}

const DEFAULT_TRANSLATIONS: Record<KundaliLang, KundaliTranslations> = {
  en: {
    name: "Your Name",
    birthDate: "Birth Date",
    birthTime: "Birth Time",
    birthPlace: "Birth Place",
    optional: "(optional)",
    timeUnknownToggle: "Don't know your birth time?",
    timeUnknownExplainer:
      "No problem — we'll read the planets with a noon default, which holds true for your rashi and nakshatra. One honest note: your Lagna, houses, and dasha cannot be read without the exact time.",
    submit: "Generate Free Kundali →",
    namePlaceholder: "Enter your full name",
    placePlaceholder: "City, State (e.g. Chennai, Tamil Nadu)",
    savedNote: "Your reading is saved securely so you can access it anytime.",
    loading: "Calculating your stars...",
    phone: "Mobile number",
    phonePlaceholder: "98765 43210",
    phoneReason: "We'll send your reading on WhatsApp.",
    email: "Email",
    emailPlaceholder: "you@example.com (optional)",
    placeChange: "Change",
    placeDidYouMean: "Did you mean",
    retryTitle: "Couldn't reach the stars just now",
    retryBody: "Your details are saved. The connection slipped — tap to try once more.",
    retryAction: "Try again",
  },
  hi: {
    name: "आपका नाम",
    birthDate: "जन्म तिथि",
    birthTime: "जन्म समय",
    birthPlace: "जन्म स्थान",
    optional: "(वैकल्पिक)",
    timeUnknownToggle: "जन्म समय नहीं पता?",
    timeUnknownExplainer:
      "कोई बात नहीं — हम दोपहर 12 बजे मानकर ग्रह स्थिति निकाल देंगे, जो राशि और नक्षत्र के लिए सही रहती है। पर ध्यान रहे: लग्न, भाव और दशा सही जन्म समय के बिना नहीं बताए जा सकते।",
    submit: "निःशुल्क कुंडली बनाएं →",
    namePlaceholder: "अपना पूरा नाम लिखें",
    placePlaceholder: "शहर, राज्य (उदा. चेन्नई, तमिलनाडु)",
    savedNote: "आपकी कुंडली सुरक्षित रूप से सहेजी जाती है ताकि आप इसे कभी भी देख सकें।",
    loading: "गणना हो रही है...",
    phone: "Mobile number",
    phonePlaceholder: "98765 43210",
    phoneReason: "Aapki reading WhatsApp par bhejenge.",
    email: "Email",
    emailPlaceholder: "you@example.com (optional)",
    placeChange: "Badlein",
    placeDidYouMean: "Kya aapka matlab tha",
    retryTitle: "Abhi taaron tak nahi pahunch paaye",
    retryBody: "Aapki details safe hain. Connection toot gaya — ek baar phir try karein.",
    retryAction: "Phir try karein",
  },
};

export function getKundaliTranslations(
  language: KundaliLang,
  overrides: {
    submitLabel?: string;
    savedNote?: string;
    loadingLabel?: string;
    namePlaceholder?: string;
    placePlaceholder?: string;
  } = {}
): KundaliTranslations {
  const defaults = DEFAULT_TRANSLATIONS[language];
  return {
    ...defaults,
    submit: overrides.submitLabel || defaults.submit,
    namePlaceholder: overrides.namePlaceholder || defaults.namePlaceholder,
    placePlaceholder: overrides.placePlaceholder || defaults.placePlaceholder,
    savedNote: overrides.savedNote || defaults.savedNote,
    loading: overrides.loadingLabel || defaults.loading,
  };
}
